import React from 'react';
import Title from '../titles/Title';
import { Row,Col } from 'react-bootstrap';

  // Static list of client names
  const clients = [
    "Himachal Organic Bee Products",
    "Pashmina Ladhaki",
    "Khadi Natural Care",
    "SPGL Industries pvt.ltd",
    "Glister Food Pvt.ltd",
    "Insight Food Pvt.ltd",
    "Umang Aayurveda",
    "Kisan and sons",
    "Meezan Enterprises",
    "Safa Honey",
    "Safiya Food Company",
    "Connedit Business Solution Pvt.ltd",
  ];


const ClientSection = () => {
  return (
    <div className="section-container mb-5">
    <Title classname="text-center mb-5" heading="Our Clients" />
    <div className="container">
      <Row className="justify-content-center">
        {clients.map((clientName, index) => (
          <Col key={index} md={3} className="d-flex">
            <div className="client-container mb-3 w-100 align-items-center">
              {clientName}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  </div>  )
}

export default ClientSection